export default __webpack_public_path__ + "static/media/30_gallery.dbf439ce.jpg";